// ===== Phase 11: v-permission 自定义指令 =====
// 按钮级权限控制，无权限时 DOM 直接移除（非 display:none），防止 F12 绕过
//
// 用法：
//   v-permission="'po:approve'"
//   v-permission="['po:approve', 'finance:pay']"

import type { Directive } from 'vue'
import { hasPermission } from '../config/auth'

export const vPermission: Directive<HTMLElement, string | string[]> = {
  mounted(el, binding) {
    if (!binding.value) return // 未传值则不限制
    if (!hasPermission(binding.value)) {
      // 保存父节点引用用于 comment 占位
      const comment = document.createComment(`v-permission: ${JSON.stringify(binding.value)}`)
      el.parentNode?.replaceChild(comment, el)
      // 将 comment 节点存到 el 上方便 updated 生命周期无需再处理
      ;(el as any).__v_permission_comment = comment
    }
  },
  updated(el, binding) {
    if (!binding.value) return
    if (!hasPermission(binding.value)) {
      if (el.parentNode) {
        const comment = document.createComment(`v-permission: ${JSON.stringify(binding.value)}`)
        el.parentNode.replaceChild(comment, el)
        ;(el as any).__v_permission_comment = comment
      }
    }
  }
}
